import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ReleaseEnvironmentSchema } from './shapes';

/**
 * Reads back the published Tauri static latest.json from the updates CDN
 * (server-side fetch — avoids CORS and verifies the write actually landed).
 * `manifest: null` = the CDN has no object yet (never published, or the
 * post-publish manifest write failed).
 */
export const getUpdateManifest = defineEndpoint({
  method: 'GET',
  path: '/v1/release-products/:productId/update-manifest',
  params: z.object({ productId: z.string().uuid() }),
  query: z.object({ environment: ReleaseEnvironmentSchema }),
  body: z.undefined(),
  response: z.object({
    data: z.object({
      url: z.string(),
      // Loose record so manifest format changes never break this endpoint.
      manifest: z.record(z.unknown()).nullable(),
    }),
  }),
});
